import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Route } from "./route";
import { useTableRefresh } from "@/components/custom/data-table/data-table-context";

import { showActionErrorToast } from "@/state/error-toast";

export function useScheduledTrainingJob() {
  const { scheduledJobId, scheduledJobQuery, actions } =
    Route.useRouteContext();
  const scheduledJobResult = useQuery(scheduledJobQuery);
  const queryClient = useQueryClient();
  const tableRefresh = useTableRefresh();
  const refresh = (options?: { propagate?: boolean }) => {
    if (options?.propagate) {
      tableRefresh();
    }
    queryClient.invalidateQueries({ queryKey: scheduledJobQuery.queryKey });
  };
  const edit = useMutation({
    ...actions.updateSchedule
      .assign({ id: scheduledJobId })
      .asMutationOptions(),
    onSuccess: () => refresh({ propagate: true }),
    onError: (err) => showActionErrorToast(err),
  });
  return {
    scheduledJobResult,
    scheduledJobId,
    scheduledJobQuery,
    refresh,
    edit,
  };
}
